import React, { useState, useEffect, useCallback } from 'react'
import { Button, FormControl } from 'react-bootstrap'
import Select from 'react-select'
import DateRangePicker from 'react-bootstrap-daterangepicker';
import _ from 'lodash'
import classNames from 'classnames';
import FilterDropdownComponent from './filter_dropdown'
import FilterTagComponent from './filter_tag'
import * as Constants from '../../../helpers/constants'
import { ApiHelper } from '../../../helpers/apihelper'
import { getDateRangePickerInitialSettings } from '../../../helpers/helper'

import 'bootstrap-daterangepicker/daterangepicker.css'
import './../../../static/css/filters.css'
import './../../../static/css/daterangepicker.css'

const _filterReducer = ({ type, filter, state }) => {
  if (type === 'default') {
    return filter
  }
  if (type === 'remove') {
    delete state[filter.filter_value]
    return _.assign({}, state)
  }
  else if (type === 'reset') {
    state = _.assign({}, filter)
    return state
  }
  return {
    ...state,
    [filter.filter_value]: {
      value: filter.value,
      label: filter.label,
      filter_label: filter.filter_label
    }
  }
}

const initialState = {
  selectedValue: 'Last 7 days (Including Today)',
  organizationFiltersList: [],
  tagsList: [],
  selectedTagOptions: [{
    'value': 'sys:no_usage',
    'label': 'No Usage',
    'description': 'Users who have not done any activity in last 3 months'
  }]
}

const FiltersComponent = (props) => {

  const [state, setState] = useState(initialState)

  const {
    filterState,
    onSetFilters,
    onSearch,
    clearSearch,
    searchValue,
    filters,
    filtersToInclude,
    className = 'filter-container',
    skipFilter = [],
    resetFilters,
    client,
    refreshPage,
    searchPlaceholder,
    listName,
    onListNameSearch,
    service,
    showCloseIcon = true,
    dateFieldKey,
    renderedFrom
  } = props

  const dateRangePickerInitialSettings = getDateRangePickerInitialSettings(renderedFrom)

  useEffect(() => {
    setState(initialState)
  }, [client, service])

  //organization api call
  const getOrganizationNames = useCallback((skip, limit, sorting) => {
    let requestBody = {
      skip: skip,
      limit: limit,
      sort: sorting,
    }

    let body = _.pick(requestBody, ApiHelper(client, 'ORGANIZATION_NAMES').API_BODY)

    ApiHelper(client, 'ORGANIZATION_NAMES').API(client, body)
      .then((res) => {
        if (res.status === Constants.CO_API.SUCCESS) {
          setState(prevState => ({ ...prevState, organizationFiltersList: res.data.data }))
        }
      })
      .catch((err) => {
        console.log('org list api err', err)
      })
  }, [client])

  useEffect(() => {
    if (_.includes(filtersToInclude, 'org_filter') && client)
      getOrganizationNames(0, 200, { created_on: 'desc' })
  }, [getOrganizationNames, filtersToInclude, client])

  //organization filter values
  const options = state.organizationFiltersList && state.organizationFiltersList.map((item) => ({
    value: item.id,
    label: item.name,
  }))

  const getTagsNames = useCallback(() => {
    ApiHelper(client, 'TAGS_NAMES').API(client)
      .then((response) => {
        if (response.status === Constants.CO_API.SUCCESS) {
          let tagOptions = _.get(response, 'data.tags', [])

          if (!_.isEmpty(tagOptions)) {

            tagOptions = tagOptions.map((item) => ({
              value: item.name,
              label: item.display_name,
              description: item.description,
            }))

            tagOptions.unshift({ value: 'all', label: 'All', description: '' })

            setState(prevState => ({
              ...prevState,
              tagsList: tagOptions
            }))
          }
        }
      })
      .catch((err) => {
        console.error('Tag list API error:', err)
      })
  }, [client])


  useEffect(() => {
    if (_.includes(filtersToInclude, 'tags_filter') && client) {
      getTagsNames()
    }
  }, [getTagsNames, filtersToInclude, client])

  const onSelectFilter = (eventKey) => {
    if (eventKey) {
      onSetFilters(_filterReducer({ type: 'add', filter: eventKey, state: filterState }))
    }
  }

  const onTagsFilterSelect = (selectedOptions, event) => {
    let filters = filterState

    let selected_options = selectedOptions

    if (event.action === 'select-option' && event.option.value === 'all') {
      selected_options = [event.option]
      filters.tags_filter = []
    } else if (event.action === 'clear') {
      selected_options = [{ value: 'all', label: 'All', description: '' }]
      filters.tags_filter = []
    } else {
      selected_options = selectedOptions.filter(ele => ele.value !== 'all')
      filters.tags_filter = selected_options.map((opt => opt.value))
    }

    setState(prevState => ({
      ...prevState,
      selectedTagOptions: selected_options
    }))

    onSetFilters(filters)
  }

  const onOrganizationFilterSelect = (event) => {
    let org_filter = {
      value: event?.value,
      label: '',
      filter_label: event?.label,
      filter_value: 'org_filter'
    }
    onSetFilters(_filterReducer({ type: 'add', filter: org_filter, state: filterState }))
  }

  const onRemoveFilter = (key, filter) => {
    let removed_filter = {
      value: '',
      label: '',
      filter_label: filter.filter_label,
      filter_value: key
    }
    onSetFilters(_filterReducer({ type: 'remove', filter: removed_filter, state: filterState }))
  }

  const onResetFilters = () => {
    onSetFilters(_filterReducer({
      type: 'reset',
      filter: resetFilters,
      state: filterState
    }))
    setState(prevState => ({
      ...prevState,
      selectedValue: 'Last 7 days (Including Today)',
      selectedTagOptions: [{
        'value': 'sys:no_usage',
        'label': 'No Usage',
        'description': 'Users who have not done any activity in last 3 months'
      }]
    }))
    // clearListNameSearch()
    clearSearch()
  }

  const handleDateRangeApply = (event, picker) => {
    const selectedPreset = picker.chosenLabel;
    let selectedValue = '';

    if (selectedPreset === 'Custom Range') {
      const startDate = picker.startDate.format('DD MMM YYYY');
      const endDate = picker.endDate.format('DD MMM YYYY');
      selectedValue = `${startDate} - ${endDate}`;
    } else {
      selectedValue = selectedPreset === 'All' ? 'All' : selectedPreset;
    }

    setState(prevState => ({ ...prevState, selectedValue }));

    let valueObj = null;

    if (selectedPreset !== 'All') {
      if (selectedPreset === 'Custom Range') {
        valueObj = {
          key: dateFieldKey || 'created_on',
          start_date: picker.startDate.toISOString(),
          end_date: picker.endDate.toISOString()
        };
      } else {
        valueObj = {
          key: dateFieldKey || 'created_on',
          preset: Constants.DATE_RANGE_PRESETS[selectedPreset]
        };
      }
    }

    let date_filter = {
      value: valueObj,
      label: '',
      filter_label: 'date_range',
      filter_value: 'date_range'
    };
    onSetFilters(_filterReducer({ type: 'add', filter: date_filter, state: filterState }));
  };

  const formatTagsOptionsLabel = (options, { context }) => {
    if (context === 'menu') {
      return (
        <>
          <div>{options.label}</div>
          <div>
            <small className='tag__description'>{options.description}</small>
          </div>
        </>
      )
    } else {
      return options.label
    }
  }

  return (
    <div className={className}>
      {
        _.includes(filtersToInclude, 'main_filters')
          ?
          <div className="filter-comp user-list-filter-comp">
            <FilterDropdownComponent
              filters={filters}
              onSelectFilter={onSelectFilter}
            />
            <div className="list-selected-filters">
              <FilterTagComponent
                selectedFilters={filterState}
                onRemoveSelectedFilter={onRemoveFilter}
                skipFilter={skipFilter}
                showCloseIcon={showCloseIcon}
              />
            </div>
          </div>
          : null
      }
      {
        _.includes(filtersToInclude, 'daterange_filter')
          ?
          <div className='day-filter'>
            <DateRangePicker
              initialSettings={{ ...dateRangePickerInitialSettings }}
              onApply={handleDateRangeApply}
            >
              <FormControl
                type="text"
                className='cursor-pointer date-range-input'
                value={state.selectedValue}
                readOnly={true}
              />
            </DateRangePicker>
          </div>
          : null
      }
      {
        _.includes(filtersToInclude, 'reset_filter')
          ?
          <div>
            <Button
              className='filter-reset-btn'
              size="md"
              onClick={onResetFilters}
            >
              Reset
            </Button>
          </div>
          : null
      }
      {
        _.includes(filtersToInclude, 'org_filter')
          ?
          <div>
            <Select
              onChange={onOrganizationFilterSelect}
              options={options}
              isClearable={true}
              searchable={true}
              placeholder="Select Organization"
              className='org-filter mx-1'
            />
          </div>
          : null
      }
      {
        _.includes(filtersToInclude, 'tags_filter')
          ?
          <div>
            <Select
              value={state.selectedTagOptions}
              onChange={onTagsFilterSelect}
              options={state.tagsList}
              isClearable={true}
              isMulti={true}
              isSearchable={true}
              placeholder="Select Tags"
              className='search-by-tags-filter'
              classNamePrefix='search-by-tags-filter'
              formatOptionLabel={formatTagsOptionsLabel}
            />
          </div>
          : null
      }
      {
        _.includes(filtersToInclude, 'search_filter')
          ?
          <div className='search-container'>
            <FormControl
              type="text"
              placeholder={searchPlaceholder ? searchPlaceholder : 'Search...'}
              onChange={onSearch}
              value={searchValue}
            />
            {searchValue && (
              <button
                className='clear-button'
                onClick={clearSearch}
              >
                x
              </button>
            )}
          </div>
          : null
      }
      {
        _.includes(filtersToInclude, 'list_name_search')
          ?
          <FormControl
            type="search"
            onChange={onListNameSearch}
            placeholder={'Search by list name'}
            className={classNames(listName ? 'form-control search-val' : 'form-control search-empty')}
            value={listName}
            style={{ height: '35px' }}
          />
          : null
      }
      {
        _.includes(filtersToInclude, 'refresh_page')
          ?
          <Button
            variant="outline-secondary"
            className='filter-refresh-btn'
            title="Refresh"
            onClick={() => refreshPage()}
          >
            <i className="fa fa-refresh"></i>
          </Button>
          : null
      }
    </div>
  )
}

FiltersComponent.displayName = 'FiltersComponent'

export default FiltersComponent;
